import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center bg-purple-50/50 px-5">
      <div className="w-full max-w-md rounded-3xl border border-purple-100 bg-white p-10 text-center shadow-2xl shadow-purple-600/10">
        <XCircle className="mx-auto h-14 w-14 text-slate-300" />
        <h1 className="mt-6 font-heading text-2xl font-bold text-slate-900">Pagamento annullato</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">
          Nessun addebito è stato effettuato. Quando sei pronto, MIR-IA ti aspetta: 997€ all'anno, meno di una cena al
          mese.
        </p>
        <Link
          to="/"
          data-testid="cancel-back-home-link"
          className="mt-8 inline-block rounded-full bg-purple-600 px-8 py-3 font-heading text-sm font-bold text-white transition-colors hover:bg-purple-700"
        >
          Torna alla landing
        </Link>
      </div>
    </div>
  );
}
